import { PrimaryInfo } from './../util';
import { Board } from "../../models/Board";

export const getSuggestion = (board: Board): PrimaryInfo => {
    return {
        name: board.name,
        id: board.id
    };
};
